import { inject, type InjectionKey } from 'vue'
import type { ShowChangeEmailParams } from '../modals/TenantUserModalChangeEmail.vue'
import type { ShowChangeNameModalParams } from '../modals/TenantUserModalChangeName.vue'
import type { ShowChangeJobTitleModalParams } from '../modals/TenantUserModalChangeJobTitle.vue'
import type { ShowChangePhoneNumberModalParams } from '../modals/TenantUserModalChangePhoneNumber.vue'
import type { ShowScheduleActivationModalParams } from '../modals/TenantUserModalScheduleActivation.vue'
import type { ShowScheduleDeactivationModalParams } from '../modals/TenantUserModalScheduleDeactivation.vue'
import type { ShowActivateModalParams } from '../modals/TenantUserModalActivate.vue'
import type { ShowDeactivateModalParams } from '../modals/TenantUserModalDeactivate.vue'
import type { ShowGrantTenantAdminModalParams } from '../modals/TenantUserModalGrantTenantAdmin.vue'
import type { ShowRevokeTenantAdminModalParams } from '../modals/TenantUserModalRevokeTenantAdmin.vue'

export interface TenantUserModalsContext {
  showChangeEmail: (params: ShowChangeEmailParams) => void
  showChangeName: (params: ShowChangeNameModalParams) => void
  showChangeJobTitle: (params: ShowChangeJobTitleModalParams) => void
  showChangePhoneNumber: (params: ShowChangePhoneNumberModalParams) => void
  showScheduleActivation: (params: ShowScheduleActivationModalParams) => void
  showScheduleDeactivation: (
    params: ShowScheduleDeactivationModalParams
  ) => void
  showActivate: (params: ShowActivateModalParams) => void
  showDeactivate: (params: ShowDeactivateModalParams) => void
  showGrantTenantAdmin: (params: ShowGrantTenantAdminModalParams) => void
  showRevokeTenantAdmin: (params: ShowRevokeTenantAdminModalParams) => void
}

export const tenantUserModalsKey = Symbol(
  'tenant-user-modals'
) as InjectionKey<TenantUserModalsContext>

export function useTenantUserModals() {
  return inject(tenantUserModalsKey)
}
